import React, { useMemo, useCallback } from 'react'
import AuthenticatedLayout from '../../components/layouts/authenticated_layout'
import LoadingSpinner from '../../components/loading/loading_spinner'
import { useOwnFavorite } from '../../hooks/use_own_favorite'
import EnterpriseCard from '../../components/cards/enterprise_card'
import RadioButtonGroup from '../../components/buttons/radio_button_group'
import { useInfiniteScroll } from '../../hooks/use_infinite_scroll'
import type { RadioButtonType } from '../../components/buttons/radio_button_group'
import {
  EnterpriseSortType,
  EnterpriseSortTypeLabel,
  EnterpriseSortTypeValue,
} from '../../types/enterprise'
import Breadcrumb from '../../components/common/breadcrumb'

const FavoriteEnterprisesPage: React.FC = () => {
  const {
    isLoading,
    isLoadingMore, // 追加ローディング中かどうか
    hasMore, // 追加読み込み可能かどうか
    enterprises,
    loadMore,
    changeSort,
    currentSort,
  } = useOwnFavorite()

  // 無限スクロールの設定
  const { LoadingElement } = useInfiniteScroll(loadMore, isLoadingMore, hasMore)

  const handleSortChange = useCallback(
    (type: EnterpriseSortTypeValue) => {
      if (type !== currentSort) {
        changeSort(type)
      }
    },
    [currentSort, changeSort]
  )

  const sortButtons: RadioButtonType[] = useMemo(
    () => [
      // TODO: マッチング率ソートはパフォーマンス改善後に有効化
      // {
      //   label: EnterpriseSortTypeLabel[EnterpriseSortType.MATCHING_RATE],
      //   onClick: () => handleSortChange(EnterpriseSortType.MATCHING_RATE),
      // },
      {
        label: EnterpriseSortTypeLabel[EnterpriseSortType.CREATED_AT],
        onClick: () => handleSortChange(EnterpriseSortType.CREATED_AT),
      },
      {
        label: EnterpriseSortTypeLabel[EnterpriseSortType.NAME],
        onClick: () => handleSortChange(EnterpriseSortType.NAME),
      },
    ],
    [handleSortChange]
  )

  return (
    <AuthenticatedLayout>
      <div className="container mx-auto px-4 py-8">
        <Breadcrumb
          items={[
            { label: 'ホーム', path: '/dashboard' },
            { label: 'お気に入り企業' },
          ]}
        />

        {/* ヘッダー部分：タイトルとソートボタン */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">お気に入り企業一覧</h1>
          <RadioButtonGroup buttons={sortButtons} />
        </div>
        {/* レンダリング部分 */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {isLoading && enterprises.length === 0 ? (
            <div className="flex justify-center py-20 col-span-full">
              <LoadingSpinner />
            </div>
          ) : enterprises.length === 0 ? (
            <div className="col-span-full">
              <div className="text-center py-8 text-main-darkgray">
                お気に入り企業がありません。
              </div>
            </div>
          ) : (
            <>
              {enterprises.map((enterprise, index) => (
                <EnterpriseCard
                  key={`${enterprise.id}-${index}`}
                  enterprise={enterprise}
                  initialized={!isLoading}
                />
              ))}
            </>
          )}

          {enterprises.length > 0 && hasMore && LoadingElement}
        </div>
      </div>
    </AuthenticatedLayout>
  )
}

export default FavoriteEnterprisesPage
